/**
 * Header scroll behavior for Amulet Labs.
 * Toggles `.header--scrolled` on `.shopify-section-header` based on whether
 * the hero video carousel has scrolled past the header. CSS in
 * sections/header.liquid handles all visual styling (colors, logo swap, etc).
 *
 * Runs once per page load. Re-binds DOM refs on shopify:section:load so the
 * theme editor stays in sync when sections reload.
 */
(function () {
  if (window.__amuletHeaderScrollInit) return;
  window.__amuletHeaderScrollInit = true;

  var headerSection = null;
  var headerTop = null;
  var ticking = false;

  function refreshRefs() {
    headerSection = document.querySelector('.shopify-section-header');
    headerTop = document.querySelector('.shopify-section-header .header__top');
  }

  function setScrolled(on) {
    if (!headerSection) return;
    headerSection.classList.toggle('header--scrolled', !!on);
  }

  function update() {
    ticking = false;
    if (!headerSection || !headerTop) return;

    var carousel = document.querySelector('.hero-carousel-section');

    // No carousel on this page → header is always in scrolled (opaque) state.
    if (!carousel) { setScrolled(true); return; }

    var carouselBottom = carousel.getBoundingClientRect().bottom;
    var headerHeight = headerTop.offsetHeight;
    setScrolled(carouselBottom <= headerHeight);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function init() {
    refreshRefs();
    if (!headerSection) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // Theme editor lifecycle: re-bind refs when header or carousel reloads.
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (
      t.classList.contains('shopify-section-header') ||
      t.classList.contains('hero-carousel-section')
    ) {
      refreshRefs();
      update();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
